import Backbone from 'backbone';
import template from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/DisclaimerPopUpView.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export class DisclaimerPopUpView extends Backbone.View {
  initialize({
    viewModel,
  } = {}) {
    this.viewModel = viewModel;
  }
  render() {
    this.$el.html(template({ i18n }));

    return this;
  }
}
